var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{class:_vm.$style.deviceNumber},[_vm._v(" "+_vm._s(_vm.numberOfDevices)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }